import { Component, Input, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LinkedEducatorHeaderModalComponent } from '../educator-header/linked-educator-header-modal/linked-educator-header-modal.component';
import { ComponentBaseClass } from '../component-base-class/component-base-class.component';

export interface LinkedEducatorContext {
  isPrimaryDuplicateEducator: boolean;
  duplicateEducators: {
    personId: number;
    isPrimary: boolean;
  }[];
}
@Component({
  selector: 'cert-linked-educator-icon',
  templateUrl: './linked-educator-icon.component.html',
  styles: `
    .icon-hover {
      :hover {
        cursor: pointer;
        color: black;
      }
    }
  `,
  standalone: false,
})
export class LinkedEducatorIconComponent extends ComponentBaseClass implements OnDestroy {
  @Input() linkedEducatorContext!: LinkedEducatorContext;
  @Input() disabled = false;

  constructor(private readonly modalService: NgbModal) {
    super();
  }

  getDuplicateEducatorText(): string {
    const part1 = 'This educator has been identified as a duplicate record.';
    const part2 = this.linkedEducatorContext.isPrimaryDuplicateEducator ? 'This is the primary EIN.' : '';
    return `${part1} ${part2}`;
  }

  openLinkedEducatorsModal() {
    if (this.disabled) {
      return;
    }

    const modalRef = this.modalService.open(LinkedEducatorHeaderModalComponent, {
      backdrop: 'static',
      size: 'md',
      centered: true,
    });

    modalRef.componentInstance.linkedEducatorContext = this.linkedEducatorContext;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.modalService.dismissAll();
  }
}
